// @flow
import * as React from 'react'

import './FormErrorAlert.scss'

export type Props = {
  children: React.Node,
}

export default class FormErrorAlert extends React.Component<Props> {
  render = () => {
    return <div className="FormErrorAlert">{this.props.children}</div>
  }
}
